<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-col cols="12" sm="12" md="12">
                <v-row dense class="p-0 m-0" v-if="scheme_details!=''">
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Subject Code" readonly dense outlined rounded v-model="scheme_details[0].crs_code"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Subject Name" readonly dense outlined rounded v-model="scheme_details[0].crs_name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Teacher" readonly dense outlined rounded v-model="scheme_details[0].inst_name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Standard" readonly dense outlined rounded v-model="scheme_details[0].standard"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Division" readonly dense outlined rounded v-model="scheme_details[0].division"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Academic Year" readonly dense outlined rounded v-model="scheme_details[0].academicyear"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Assessment Type" readonly dense outlined rounded v-model="scheme_details[0].assessmenttype"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Evaluation Type" readonly dense outlined rounded v-model="scheme_details[0].evaluationtype"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Entry Type" readonly dense outlined rounded v-model="scheme_details[0].coursemarksentrytype"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Evaluated Marks" readonly dense outlined rounded v-model="scheme_details[0].evaluated_marks"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Converted Marks" readonly dense outlined rounded v-model="scheme_details[0].converted_marks"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Rubric Scheme Header" readonly dense outlined rounded v-model="scheme_details[0].rubric_header"></v-text-field>
                    </v-col>
                </v-row>
                <!-- <v-row dense class="p-0 m-0" v-if="scheme_details[0].learners.length > 0">
                    <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                        <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                    </v-col>
                </v-row> -->
                <v-row dense class="p-0 m-0" v-if="scheme_details[0].learners.length > 0">
                    <v-col cols="12" sm="12" md="12" class="d-flex justify-end p-0 m-0">
                        <v-btn rounded color="success" class="mb-2" small @click="exportToExcel">
                            <v-icon left small>mdi-file-excel</v-icon>
                            Export to Excel
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="!scheme_details[0].expire">
                    <v-col class="d-flex justify-center">
                        <span class="slide">Marks Entry Date Is Over..!</span>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <!-- {{component_headers}} -->
                        <v-simple-table dense class="elevation-1" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">PRN No.</th>
                                    <th class="">Name</th>
                                    <th class="">Roll No.</th>
                                    <th class="">Academic Year</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="" v-if="tabs == 0">Is Absent</th>
                                    <th class="" v-if="tabs == 0">Medical Leave</th>
                                    <th class="" v-if="tabs == 1">Is Applied For Re-exam ?</th>
                                    <th class="" v-for="item in rubric_list" :key="item.rubricsscheme_id">
                                        <center>{{ item.rubricsscheme }} ({{ item.rubricsscheme_marks}})</center>
                                    </th>
                                    <th class="">
                                        Add Marks
                                    </th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="s in scheme_details[0].learners" :key="s.id">
                                    <td>{{s.srno}}</td>
                                    <td>{{s.registration_number}}</td>
                                    <td>{{s.name}}</td>
                                    <td>{{s.rollno}}</td>
                                    <td>{{s.academicyear}}</td>
                                    <td>{{s.std}}</td>
                                    <td>{{s.div}}</td>
                                    <td v-if="tabs == 0">
                                         <input
                                            type="checkbox"
                                            v-model="s.isabsent"
                                            :disabled="s.medical_leave"
                                            @change="handleAbsentChange(s)"
                                        >
                                        <!-- <input type="checkbox" v-model="s.isabsent" color="#0F2027" /> -->
                                    </td>
                                    <td v-if="tabs == 0">
                                         <input
                                            type="checkbox"
                                            v-model="s.medical_leave"
                                            :disabled="s.isabsent"
                                            @change="handleMedicalLeaveChange(s)"
                                        >
                                        <!-- <input type="checkbox" v-model="s.medical_leave" color="#0F2027" /> -->
                                    </td>
                                     <td v-if="tabs == 1">
                                          <input
                                            type="checkbox"
                                            v-model="s.is_applied_for_reexam">
                                    </td>
                                    <td v-for="item1 in s.rubric_list" :key="item1.rubricsscheme_id" v-if="tabs == 0">
                                        <span v-for="k in rubric_list" :key="k.rubricsscheme_id">
                                            <span v-if="k.rubricsscheme_id == item1.rubricsscheme_id">
                                                <input
                                                    placeholder="Enter marks."
                                                    v-if="s.isabsent == false && s.medical_leave == false"
                                                    class="input text-center"
                                                    type="number"
                                                    v-model="item1.maxmarks"
                                                    :name="item1.rubricsscheme_id"
                                                    min="0"                              
                                                    onkeypress="javascript:return isNumber(item1.rubricsscheme_marks)"
                                                    :rules="[v => !!v || 'Required' || v >= 0]"
                                                />
                                            </span>
                                        </span>
                                    </td>
                                    <td v-else>
                                         <span v-for="k in rubric_list" :key="k.rubricsscheme_id">
                                            <span v-if="k.rubricsscheme_id == item1.rubricsscheme_id">
                                                <input
                                                    placeholder="Enter marks."
                                                    class="input text-center"
                                                    type="number"
                                                    v-if="s.is_applied_for_reexam == true"
                                                    v-model="item1.reexam_obtained_marks"
                                                    :name="item1.rubricsscheme_id"
                                                    min="0"                              
                                                    onkeypress="javascript:return isNumber(item1.rubricsscheme_marks)"
                                                    :rules="[v => !!v || 'Required' || v >= 0]"
                                                />
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <v-btn small v-if="!scheme_details[0].expire" disabled rounded class="button" @click="savesinglemarksentry(scheme_details,s.rubric_list,s.cid,s.isabsent,s.medical_leave)">
                                            Save
                                        </v-btn>
                                        <v-btn small v-else rounded class="button" @click="savesinglemarksentry(scheme_details,s.rubric_list,s.cid,s.isabsent,s.medical_leave,s.is_applied_for_reexam)">
                                            Save
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
                <v-row v-if="!scheme_details[0].expire">
                    <v-col cols="12" sm="12" class="d-flex justify-center">
                        <v-btn rounded class="button" disabled :loading="loader" @click="savemarksentry(scheme_details,scheme_details[0].learners)">
                            Save
                        </v-btn>
                    </v-col>
                    <v-col class="d-flex justify-center">
                        <span class="slide">Marks Entry Date Is Over..!</span>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col class="d-flex justify-center">
                        <v-btn rounded class="button" :loading="loader" @click="savemarksentry(scheme_details,scheme_details[0].learners)">
                            Save
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import * as XLSX from "xlsx";
    export default {
        props: {
            scheme_details: String,
            rubric_list: String,
            allow_reexam_marks_entry: String,
            tabs: String
        },
        data() {
            return {
                loader: false,
                loader1: false,
                search: null,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ev_marks: null,
                leaner_marks_list: [],
                learner_id: [],
                leaner_marks_id_list: [],
                single_marks_list: [],
                single_marks_id_list: [],
                single_ass_scheme_marks: [],
                ass_scheme_marks: [],
                ass_scheme_id_marks: [],
                ass_reexam_scheme_marks:[],
                ass_reexam_applied:[],
                single_reexam_marks_list:[],
                single_reexam_applied:[],
                comp_total: null,
                reexam_comp_total: null,
                org_id:null,
                headers3: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        align: "center",
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        sortable: false,
                        align: "center",
                        value: "academicyear",
                    },
                    {
                        text: "Standard",
                        sortable: false,
                        align: "center",
                        value: "std",
                    },
                    {
                        text: "Division",
                        sortable: false,
                        align: "center",
                        value: "div",
                    },
                    {
                        text: "PRN No",
                        sortable: false,
                        align: "center",
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        sortable: false,
                        align: "center",
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        sortable: false,
                        align: "center",
                        value: "name",
                    },
                    {
                        text: "Absent",
                        sortable: false,
                        align: "center",
                        value: "isabsent",
                    },
                    {
                        text: "Marks \ Grade",
                        sortable: false,
                        align: "center",
                        value: "options",
                    },
                    // {
                    //     text: "Add Marks",
                    //     sortable: false,
                    //      align:"center",
                    //     value: "save",
                    // },
                ],
            };
        },
        mounted() {
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        methods: {
            handleAbsentChange(item) {
            if (item.isabsent) {
                item.medical_leave = false
                }
            },
            handleMedicalLeaveChange(item) {
                if (item.medical_leave) {
                item.isabsent = false
                }
            },
            savemarksentry(scheme_details, item) {
                for (var j = 0; j < item.length; j++) {
                    this.comp_total = 0;
                    this.reexam_comp_total = 0
                    for (var i = 0; i < item[j].rubric_list.length; i++) {
                        const rubricItem = item[j].rubric_list[i];
                        this.learner_id.push(item[j].cid)
                        this.leaner_marks_id_list.push(item[j].rubric_list[i].rubricsscheme_id);

                        if (rubricItem.maxmarks < 0 || rubricItem.rubricsscheme_marks < 0) {
                            this.showSnackbar("#b71c1c", "Marks cannot be negative.");
                            return;
                        }

                        if (rubricItem.maxmarks > rubricItem.rubricsscheme_marks) {
                            this.showSnackbar("#b71c1c", "Entered marks should not exceed rubric marks.");
                            return;
                        }
                        else if (item[j].isabsent == true) {
                           // this.learner_id.push(item[j].cid);
                           // this.leaner_marks_id_list.push(item[j].rubric_list[i].rubricsscheme_id);
                            this.leaner_marks_list.push(item[j].isabsent);
                        }
                        else if (item[j].medical_leave == true) {
                           // this.learner_id.push(item[j].cid);
                           // this.leaner_marks_id_list.push(item[j].rubric_list[i].rubricsscheme_id);
                            this.leaner_marks_list.push("ml");
                        }
                        else{
                            //this.learner_id.push(item[j].cid);
                              //  this.leaner_marks_id_list.push(item[j].rubric_list[i].rubricsscheme_id);
                            this.leaner_marks_list.push(item[j].rubric_list[i].maxmarks);
                            this.comp_total = this.comp_total + parseFloat(item[j].rubric_list[i].maxmarks);
                        }
                        this.reexam_comp_total = this.reexam_comp_total + parseFloat(item[j].rubric_list[i].reexam_obtained_marks);
                        this.single_reexam_marks_list.push(item[j].rubric_list[i].reexam_obtained_marks);
                        this.single_reexam_applied.push(item[j].rubric_list[i].is_applied_for_reexam)
                    }
                    this.ass_scheme_id_marks.push(item[j].cid);
                    if (item[j].isabsent == true) {
                      //  this.ass_scheme_id_marks.push(item[j].cid);
                        this.ass_scheme_marks.push(item[j].isabsent);
                    }
                    else if (item[j].medical_leave == true) {
                        //this.ass_scheme_id_marks.push(item[j].cid);
                        this.ass_scheme_marks.push("ml");
                    }
                    else{
                       // this.ass_scheme_id_marks.push(item[j].cid);
                        this.ass_scheme_marks.push(this.comp_total);
                    }
                    this.ass_reexam_applied.push(item[j].is_applied_for_reexam)
                    this.ass_reexam_scheme_marks.push(this.reexam_comp_total);
                }
                this.loader = true;
                const data = {
                    sem: scheme_details[0].semester_id,
                    ay: scheme_details[0].academicyear_id,
                    coff_id: scheme_details[0].courseoffering_id,
                    div_off: scheme_details[0].divisionoffering_id,
                    coff_inst: scheme_details[0].courseOfferingInstructor_id,
                    rubric_scheme_id: scheme_details[0].rubric_scheme_id,
                    std: scheme_details[0].standard_id,
                    leaner_marks_id_list: this.leaner_marks_id_list,
                    single_reexam_marks_list: this.single_reexam_marks_list,
                    single_reexam_applied: this.single_reexam_applied,
                    leaner_marks_list: this.leaner_marks_list,
                    learner_id: this.learner_id,
                    assd_id: scheme_details[0].ass_det_id,
                    ass_scheme_marks: this.ass_scheme_marks,
                    ass_scheme_id_marks: this.ass_scheme_id_marks,
                    ass_reexam_scheme_marks : this.ass_reexam_scheme_marks,
                    ass_reexam_applied : this.ass_reexam_applied
                };
                if (this.org_id == "wws"){
                    axios
                    .post("/WWSExamination/savemarkswithrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Marks Saved Successfully..."); // show snackbar on success
                            if(this.org_id == "wws"){
                                this.$router.push({
                                name: "marks-entry-icse",
                            });
                            }else{
                            this.$router.push({
                                name: "marks-entry",
                            });
                        }
                            this.loader = false;
                        }
                        else{
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        "use strict";
                        this.leaner_marks_id_list = [];
                        this.leaner_marks_list = [];
                        this.learner_id = [];
                        this.ass_scheme_marks = [];
                        this.ass_scheme_id_marks = [];
                        this.ass_reexam_scheme_marks = [];
                        this.ass_reexam_applied =[];
                        this.single_reexam_marks_list = [];
                        this.single_reexam_applied = []
                        this.loader = false;
                    });
                }else{
                axios
                    .post("/Examination/savemarkswithrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Marks Saved Successfully..."); // show snackbar on success
                            if(this.org_id == "wws"){
                                this.$router.push({
                                name: "marks-entry-icse",
                            });
                            } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else{
                            this.$router.push({
                                name: "marks-entry",
                            });
                        }
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        "use strict";
                        this.leaner_marks_id_list = [];
                        this.leaner_marks_list = [];
                        this.learner_id = [];
                        this.ass_scheme_marks = [];
                        this.ass_scheme_id_marks = [];
                        this.ass_reexam_scheme_marks = [];
                        this.single_reexam_marks_list = [];
                        this.single_reexam_applied = []
                        this.loader = false;
                        this.ass_reexam_applied = [];
                    });
                }
            },
            savesinglemarksentry(scheme_details, item, clid, isabsent, medical_leave,is_applied_for_reexam) {
                for (var i = 0; i < item.length; i++) {
                    const rubricItem = item[i];
                    if (rubricItem.maxmarks < 0 || rubricItem.rubricsscheme_marks < 0) {
                        this.showSnackbar("#b71c1c", "Marks cannot be negative.");
                        return;
                    }

                    if (rubricItem.maxmarks > rubricItem.rubricsscheme_marks) {
                        this.showSnackbar("#b71c1c", "Entered marks should not exceed rubric marks.");
                        return;
                    }
                    if (isabsent == false && medical_leave == false) {
                      //  this.single_marks_id_list.push(item[i].rubricsscheme_id);
                        this.single_marks_list.push(item[i].maxmarks);
                        this.single_ass_scheme_marks.push(item[i].maxmarks);
                    }
                    if (isabsent == true) {
                       // this.single_marks_id_list.push(item[i].rubricsscheme_id);
                        this.single_marks_list.push(isabsent);
                    }
                    if (medical_leave == true) {
                        //this.single_marks_id_list.push(item[i].rubricsscheme_id);
                        this.single_marks_list.push("ml");
                    }
                    this.single_marks_id_list.push(item[i].rubricsscheme_id);
                    this.single_reexam_marks_list.push(item[i].reexam_obtained_marks);
                    this.single_reexam_applied.push(is_applied_for_reexam)
                }
                this.loader1 = true;
                const data = {
                    sem: scheme_details[0].semester_id,
                    ay: scheme_details[0].academicyear_id,
                    coff_id: scheme_details[0].courseoffering_id,
                    div_off: scheme_details[0].divisionoffering_id,
                    coff_inst: scheme_details[0].courseOfferingInstructor_id,
                    rubric_scheme_id: scheme_details[0].rubric_scheme_id,
                    std: scheme_details[0].standard_id,
                    clid: clid,
                    assd_id: scheme_details[0].ass_det_id,
                    isabsent: isabsent,
                    medical_leave: medical_leave,
                    single_marks_id_list: this.single_marks_id_list,
                    single_marks_list: this.single_marks_list,
                    single_ass_scheme_marks: this.single_ass_scheme_marks,
                    single_reexam_marks_list :this.single_reexam_marks_list,
                    single_reexam_applied: this.single_reexam_applied
                };
                if (this.org_id == "wws"){
                    axios
                    .post("/WWSExamination/savelearnermarkswithrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Marks Save Successfully..."); // show snackbar on success
                            if(this.org_id == "wws"){
                                this.$router.push({
                                name: "marks-entry-icse",
                            });
                            } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else{
                            this.$router.push({
                                name: "marks-entry",
                            });
                        }
                            this.loader1 = false;
                        }
                        else{
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader1 = false;
                    })
                    .finally(() => {
                        "use strict";
                        this.loader1 = false;
                        this.single_marks_id_list = [];
                        this.ass_reexam_scheme_marks = [];
                        this.ass_reexam_applied = []
                        this.single_marks_list = [];
                        this.single_ass_scheme_marks = [];
                        this.single_reexam_applied = []
                    });
                }else{
                axios
                    .post("/Examination/savelearnermarkswithrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Marks Save Successfully..."); // show snackbar on success
                            if(this.org_id == "wws"){
                                this.$router.push({
                                name: "marks-entry-icse",
                            });
                            } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else{
                            this.$router.push({
                                name: "marks-entry",
                            });
                        }
                            this.loader1 = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader1 = false;
                    })
                    .finally(() => {
                        "use strict";
                        this.loader1 = false;
                        this.single_marks_id_list = [];
                        this.single_marks_list = [];
                        this.single_ass_scheme_marks = [];
                        this.single_reexam_marks_list = [];
                        this.single_reexam_applied = []
                    });
                }
            },
            isNumber(evaluated_marks) {
                var iKeyCode = evt.which ? evt.which : evt.keyCode;
                if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)) return false;
                return true;
            },
            check_marks(evaluated_marks, ev_marks) {
                if (ev_marks > evaluated_marks || ev_marks < 0) {
                    this.showSnackbar("#b71c1c", "Entered marks should be less than or equal to rubric marks and it should be positive.");
                    return;
                }
            },
            exportToExcel() {
                const learners = this.scheme_details[0].learners;

                if (!learners || learners.length === 0) {
                    this.showSnackbar("#b71c1c", "No data available to export.");
                    return;
                }

                const isReexamTab = this.tabs == 1;

                const rows = learners.map((s) => {
                    const row = {
                        "Sr. No.": s.srno,
                        "PRN No": s.registration_number,
                        "Name": s.name,
                        "Roll No": s.rollno,
                        "Academic Year": s.academicyear,
                        "Standard": s.std,
                        "Division": s.div
                    };

                    if (!isReexamTab) {
                        row["Is Absent"] = s.isabsent ? "Yes" : "No";
                        row["Medical Leave"] = s.medical_leave ? "Yes" : "No";
                    } else {
                        row["Is Applied For Re-exam"] = s.is_applied_for_reexam ? "Yes" : "No";
                    }

                    var rubricTotal = 0;
                    this.rubric_list.forEach(function (rubric) {
                        var match = null;
                        if (s.rubric_list) {
                            for (var i = 0; i < s.rubric_list.length; i++) {
                                if (s.rubric_list[i].rubricsscheme_id == rubric.rubricsscheme_id) {
                                    match = s.rubric_list[i];
                                    break;
                                }
                            }
                        }
                        var colName = rubric.rubricsscheme + " (" + rubric.rubricsscheme_marks + ")";
                        if (!isReexamTab) {
                            var val = match ? match.maxmarks : "";
                            row[colName] = (val === null || val === undefined) ? "" : val;
                            if (!s.isabsent && !s.medical_leave && val !== "" && val !== null && val !== undefined) {
                                rubricTotal += parseFloat(val) || 0;
                            }
                        } else {
                            var reVal = match ? match.reexam_obtained_marks : "";
                            row[colName] = (reVal === null || reVal === undefined) ? "" : reVal;
                        }
                    });

                    // if (!isReexamTab) {
                    //     row["Total Marks"] = (s.isabsent || s.medical_leave) ? "" : rubricTotal;
                    // }

                    return row;
                });

                const worksheet = XLSX.utils.json_to_sheet(rows);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Marks Entry");

                const colWidths = Object.keys(rows[0]).map(function (key) {
                    var maxLen = key.length;
                    rows.forEach(function (r) {
                        var val = r[key];
                        var strVal = (val === null || val === undefined) ? "" : String(val);
                        if (strVal.length > maxLen) {
                            maxLen = strVal.length;
                        }
                    });
                    return { wch: maxLen + 2 };
                });
                worksheet["!cols"] = colWidths;

                const scheme = this.scheme_details[0];
                const fileName = ("Marks_" + scheme.crs_code + "_" + scheme.standard + "_" + scheme.division)
                    .replace(/\s+/g, "_") + ".xlsx";

                XLSX.writeFile(workbook, fileName);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    .scroll {
        overflow-x: scroll;
    }
    .box {
        background-color: white !important;
        margin: 8px !important;
        padding: 8px;
        border: 2px solid #0f2027 !important;
    }
    .toolbar {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: white;
    }
    .button {
        border: 2px solid #0f2027 !important;
        color: #0f2027;
        background: transparent !important;
        border-radius: 50px;
        margin: 0.5rem !important;
    }
    .button:hover {
        color: white;
        background: #0f2027 !important;
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    input[type="number"] {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0rem !important;
        padding: 0rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>
